import { Container, loadModules } from '@evertel/di'

import { apiWebInstance } from '../api/apiWebInstance'
import { Api } from '@evertel/api'

import { DI_MODULES as SHARED_ACCOUNT_DI_MODULES } from '@evertel/account'
import { DI_MODULES as SHARED_AGREEMENTS_DI_MODULES } from '@evertel/agreements'
import { DI_MODULES as SHARED_AUTHENTICATION_DI_MODULES } from '@evertel/shared/feature-authentication-auth0'
import { DI_MODULES as SHARED_BLUE_USER_DI_MODULES } from '@evertel/blue-user'
import { DI_MODULES as SHARED_DEPARTMENT_DI_MODULES } from '@evertel/department'
import { DI_MODULES as SHARED_DEPARTMENTS_ACCESS_DI_MODULES } from '@evertel/departments-access'
import { DI_MODULES as SHARED_DOCUMENT_DI_MODULES } from '@evertel/document'
import { DI_MODULES as SHARED_DRAWER_DI_MODULES } from '@evertel/drawer'
import { DI_MODULES as SHARED_EMOJIS_DI_MODULES } from '@evertel/emojis'
import { DI_MODULES as SHARED_INTEGRATION_DI_MODULES } from '@evertel/integration'
import { DI_MODULES as SHARED_INVITES_DI_MODULES } from '@evertel/invites'
import { DI_MODULES as SHARED_MEDIA_MODULES } from '@evertel/media'
import { DI_MODULES as SHARED_MESSAGE_DI_MODULES } from '@evertel/message'
import { DI_MODULES as SHARED_PUSH_MODULE, PushImplementation } from '@evertel/push'
import { DI_MODULES as SHARED_ROOM_DI_MODULES } from '@evertel/room'
import { DI_MODULES as SHARED_SESSION_DI_MODULES } from '@evertel/session/DI_MODULES'
import { DI_MODULES as SHARED_STORE_DI_MODULES } from '@evertel/stores'
import { DI_MODULES as SHARED_THREAD_DI_MODULES } from '@evertel/thread'
import { DI_MODULES as SHARED_VERIFIED_EMAIL_DOMAINS_DI_MODULES } from '@evertel/shared/verified-email-domain'

import { DI_WEB_ADMIN_MODULE } from '@evertel/web/admin'
import { DI_MODULES as DI_WEB_CORE_MODULE } from '@evertel/web/core'
import { DI_WEB_DEPARTMENT_MODULE } from '@evertel/web/department'
import { DI_WEB_DOCUMENT_MODULE } from '@evertel/web/document'
import { DI_WEB_HEADER_MODULE } from '@evertel/web/header'
import { DI_MODULES as DI_WEB_MEDIA_MODULE } from '@evertel/web/media'
import { DI_WEB_MESSAGE_MODULES } from '@evertel/web/message'
import { DI_WEB_ROOM_MODULE } from '@evertel/web/room'
import { DI_MODULES as DI_WEB_THEME_MODULE } from '@evertel/web/theme'
import { DI_WEB_UI_MODULE } from '@evertel/web/ui'
import { DI_MODULES as DI_WEB_INVITE_MODULE } from '@evertel/web/invites'

import { Analytics as AnalyticsBase } from '@evertel/analytics'
import { Analytics as AnalyticsImp } from '../analytics/Analytics'
import { WebPushImplementation } from '@evertel/web/push'
import { LocalAsyncStorage } from '@evertel/utils'
import { LocalAsyncStorageWebImplementation } from '@evertel/web/utils'

const diContainer = new Container()
diContainer.bind(Api).toConstantValue(apiWebInstance)

loadModules(diContainer, SHARED_ACCOUNT_DI_MODULES)
loadModules(diContainer, SHARED_AGREEMENTS_DI_MODULES)
loadModules(diContainer, SHARED_AUTHENTICATION_DI_MODULES)
loadModules(diContainer, SHARED_BLUE_USER_DI_MODULES)
loadModules(diContainer, SHARED_DEPARTMENT_DI_MODULES)
loadModules(diContainer, SHARED_DEPARTMENTS_ACCESS_DI_MODULES)
loadModules(diContainer, SHARED_DOCUMENT_DI_MODULES)
loadModules(diContainer, SHARED_DRAWER_DI_MODULES)
loadModules(diContainer, SHARED_EMOJIS_DI_MODULES)
loadModules(diContainer, SHARED_INTEGRATION_DI_MODULES)
loadModules(diContainer, SHARED_INVITES_DI_MODULES)
loadModules(diContainer, SHARED_MEDIA_MODULES)
loadModules(diContainer, SHARED_MESSAGE_DI_MODULES)
loadModules(diContainer, SHARED_PUSH_MODULE)
loadModules(diContainer, SHARED_ROOM_DI_MODULES)
loadModules(diContainer, SHARED_SESSION_DI_MODULES)
loadModules(diContainer, SHARED_STORE_DI_MODULES)
loadModules(diContainer, SHARED_THREAD_DI_MODULES)
loadModules(diContainer, SHARED_VERIFIED_EMAIL_DOMAINS_DI_MODULES)

loadModules(diContainer, DI_WEB_ADMIN_MODULE)
loadModules(diContainer, DI_WEB_CORE_MODULE)
loadModules(diContainer, DI_WEB_DEPARTMENT_MODULE)
loadModules(diContainer, DI_WEB_DOCUMENT_MODULE)
loadModules(diContainer, DI_WEB_HEADER_MODULE)
loadModules(diContainer, DI_WEB_MEDIA_MODULE)
loadModules(diContainer, DI_WEB_MESSAGE_MODULES)
loadModules(diContainer, DI_WEB_ROOM_MODULE)
loadModules(diContainer, DI_WEB_THEME_MODULE)
loadModules(diContainer, DI_WEB_UI_MODULE)
loadModules(diContainer, DI_WEB_INVITE_MODULE)

diContainer.bind(AnalyticsBase).to(AnalyticsImp).inSingletonScope()

diContainer.bind(PushImplementation).to(WebPushImplementation).inSingletonScope()

diContainer.bind(LocalAsyncStorage).to(LocalAsyncStorageWebImplementation).inSingletonScope()
diContainer.bind('Platform').toConstantValue('web')

export const container = diContainer
